/**
 * Image slider implementation for displaying before/after images with sliders.
 *
 * @author Vašek Brychta <mail@vasekbrychta.cz>
 * @version 2020-02-05
 */

(function (window, $, juxtapose, undefined) {

	if (typeof $ !== 'function') {
		return console.error('brko.imageSlider.js: jQuery is missing, load it please');
	}

	var imageSlider = function () {
		this.options = {
			containerSelector: 'slider'
		};

		/**
		 * Initialize image slider.
		 *
		 * @param {object} options
		 * @param {string} options.containerSelector
		 * @returns {imageSlider|undefined}
		 */
		this.init = function (options) {
			$.extend(this.options, options);

			if (this.options.containerSelector === undefined || this.options.containerSelector.length === 0) {
				return undefined;
			}
			if (!this.checkRequirements()) {
				return undefined;
			}

			this._containers = $(this.options.containerSelector);
			if (this._containers === undefined || this._containers.length === 0) {
				return undefined;
			}

			this._baseId = this._generateId();
			this._options.basePath = $('body').data('base-path') + '/images/';
			this._containers.each(this._initializeSlider.bind(this));

			return this;
		};

		/**
		 * Basic sanity check before run.
		 *
		 * @returns {boolean}
		 */
		this.checkRequirements = function () {
			if (typeof juxtapose !== 'object') {
				console.error('brko.imageSlider.js: juxtapose is missing, load it please');
				return false;
			}

			return true;
		};


		// region Inner properties

		this._jux = juxtapose;
		this._containers = undefined;
		this._sliders = [];
		this._baseId = undefined;
		this._options = {
			basePath: undefined
		};
		this._baseJuxtaposeOptions = {
			animate: true,
			showLabels: true,
			showCredits: true,
			startingPosition: '50%',
			makeResponsive: true,
		};

		// endregion Inner properties


		// region Helper functions
		function interpretBoolean(x) {
			if (typeof (x) != 'string') {
				return Boolean(x);
			}
			return !(x === 'false' || x === '');
		}

		// endregion Helper functions


		// region Initialization

		this._initializeSlider = function (index, container) {
			var id = container.id;
			if (id === undefined || id.length === 0) {
				id = 'slider_' + this._baseId + '_' + index;
			} else {
				id = id + '_jux';
			}

			var options = this._loadJuxtaposeOptions(container);
			var images = this._loadImages(container);

			var div = document.createElement('div');
			div.id = id;
			container.appendChild(div);
			// container.parentNode.insertBefore(div, container.nextSibling);

			this._sliders.push(new juxtapose.JXSlider('#' + id, images, options));

			this._fixResizingBug(div);
		};

		this._loadJuxtaposeOptions = function (container) {
			var options = $.extend({}, this._baseJuxtaposeOptions);

			this._loadBooleanOption(options, container, 'animate');
			this._loadBooleanOption(options, container, 'showLabels');
			this._loadBooleanOption(options, container, 'showCredits');
			this._loadBooleanOption(options, container, 'makeResponsive');
			this._loadOption(options, container, 'startingPosition');

			return options;
		};

		this._loadBooleanOption = function (options, container, optionName) {
			if (container.hasAttribute(optionName)) {
				var x = {};
				x[optionName] = interpretBoolean(container.getAttribute(optionName));
				$.extend(options, x);
			}
		};

		this._loadOption = function (options, container, optionName, attributeName) {
			if (attributeName === undefined) {
				attributeName = optionName;
			}

			if (container.hasAttribute(attributeName)) {
				var x = {};
				x[optionName] = container.getAttribute(attributeName);
				$.extend(options, x);
			}
		};

		this._loadImages = function (container) {
			var beforeImage = {
				src: this._options.basePath + container.getAttribute('beforeSrc'),
			};
			this._loadOption(beforeImage, container, 'label', 'beforeLabel');
			this._loadOption(beforeImage, container, 'credit', 'beforeCredit');

			var afterImage = {
				src: this._options.basePath + container.getAttribute('afterSrc'),
			};
			this._loadOption(afterImage, container, 'label', 'afterLabel');
			this._loadOption(afterImage, container, 'credit', 'afterCredit');

			return [beforeImage, afterImage];
		};

		this._fixResizingBug = function (div) {
			var ratio = undefined;
			// following line doesn't work, the properties are not initialized yet
			// ratio = div.offsetHeight / div.offsetWidth;

			$(window).on('resize', function (event) {
				if (ratio === undefined) {
					ratio = div.offsetHeight / div.offsetWidth;
				}
				var newWidth = div.parentNode.offsetWidth;
				var newHeight = newWidth * ratio;
				$(div).css({width: newWidth, height: newHeight});
			});
		};

		// dec2hex :: Integer -> String
		this._dec2hex = function (dec) {
			return ('0' + dec.toString(16)).substr(-2);
		};

		// generateId :: Integer -> String
		this._generateId = function (len) {
			var crypto = window.crypto || window.msCrypto || {
				getRandomValues: function (array) {
					for (var i = 0, l = array.length; i < l; i++) {
						array[i] = Math.floor(Math.random() * 256);
					}
					return array;
				}
			};

			var arr = new Uint8Array((len || 10) / 2);
			crypto.getRandomValues(arr);
			return Array.from(arr, this._dec2hex).join('');
		};

		// endregion Initialization
	};

	if (window.brko === undefined) {
		window.brko = new (function () {
		});
	}

	/**
	 * Initialize image slider.
	 *
	 * @param {object} options
	 * @param {string} options.containerSelector
	 * @returns {imageSlider|undefined}
	 */
	window.brko.imageSlider = function (options) {
		return new imageSlider().init(options);
	};

})(window, window.jQuery, window.juxtapose);
